import BarChart from "@arelia-components/ui-atoms/BarChart";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { Card, CardContent, CardHeader } from "@mui/material";

type Props = {
  isLoading: boolean;
  data: { [key: string]: number; } | undefined;
};

export default function RoyaltiesByPeriod({ data = {}, isLoading }: Props ) {
  const chartData = Object.entries(data).map(([label, value]) => ({ label, value }));

  return <Card sx={styles.card}>
    <CardHeader
      title="Royalties Breakdown"
    />
    <SpinnerWrapper loading={isLoading}>
      <CardContent>
        <BarChart
          data={chartData}
          yAxisFormatter={(value: number) => `$${value}`}
          labelFormatter={({ formattedValue }: any) => `$${formattedValue}`}
        />
      </CardContent>
    </SpinnerWrapper>
  </Card>;
}

const styles = {
  card: {
    gridColumn: "span 6",
    gridRow: "span 6"
  }
};